import { useAuth } from "@stardeck-customer-apps/project-auth";
import { FileText, Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button } from "@/components/button";
import { usePageTitle } from "@/hooks/use-page-title";

export function AdminLogin() {
  usePageTitle("Sign In");
  const { isAuthenticated, isLoading, signIn, hasPermission } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") || "/";

  useEffect(() => {
    if (isAuthenticated && hasPermission("deployment:admin-panel:write")) {
      navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, hasPermission, navigate, returnTo]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isAuthenticated && !hasPermission("deployment:admin-panel:write")) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="max-w-md w-full mx-4">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary">
                <FileText className="h-6 w-6 text-primary-foreground" />
              </div>
            </div>
            <h1 className="text-2xl font-semibold text-foreground mb-2">Access Denied</h1>
            <p className="text-muted-foreground mb-6">
              You don't have permission to access the CMS admin panel. Please contact your
              administrator.
            </p>
            <Button variant="outline" onClick={() => navigate("/")}>
              Go Home
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-4">
        <div className="text-center">
          {/* Logo */}
          <div className="flex items-center justify-center mb-6">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary">
              <FileText className="h-6 w-6 text-primary-foreground" />
            </div>
          </div>

          <h1 className="text-2xl font-semibold text-foreground mb-2">Stardeck CMS</h1>
          <p className="text-muted-foreground mb-8">
            Sign in to manage your blog posts and case studies
          </p>

          {/* Sign in button */}
          <Button size="lg" className="w-full" onClick={() => signIn(returnTo)}>
            Sign in with Stardeck
          </Button>

          <p className="text-xs text-muted-foreground mt-6">
            Admin access required. Contact your administrator if you need access.
          </p>
        </div>
      </div>
    </div>
  );
}
